import { FunnelChart } from '@euler/lib/charts/FunnelChart';
import { memo } from 'react';
import { BiFunnelModel } from '../functions/biFunnelModel';
import { useBiChartTheme } from './useBiChartTheme';

/** A funnel's stages, values and rates in the chart widget's look. */
export const BiFunnelChart = memo(
  ({ model, width }: { model: BiFunnelModel; width: number }) => {
    const theme = useBiChartTheme();
    return (
      <FunnelChart
        width={width}
        stages={model.stages}
        showValues={model.showValues}
        showRates={model.showRates}
        theme={theme}
      />
    );
  },
);
